import { EpimsBaseEntityDto } from './epim-base.dto';
export class SubSubGroupTypeDto extends EpimsBaseEntityDto {
  SubSubGroupTypeName: string;
  SubscriptionUserId: string;
  Version: number;
}
